import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/xhef.actions';
import * as actions_local from '../../../actions/locals.actions';
import * as actions_products from '../../../actions/product.actions';
import * as actions_machine from '../../../actions/machine.actions';
import * as home from '../../../actions/process.home.actions';
import * as actions_forecast from '../../../actions/forecast.actions';

import TabContainer from './TabContainer';
import Panel from './Panel';
import Popup from './Popup';
import Waste from './WastePopup';
import Production from './ProductionPopup';
import CommandPopup from './CommandPopup';
import Run from './RunCommandPopup';
import Machine from './MachinePopup';
import Error from '../../dialogs/Error';
import Loading from '../../dialogs/loading';
import Snackbar from '../../labels/Snackbar';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Fab from '@material-ui/core/Fab';

import { ExpandMenu, ContractMenu, DotsIcon } from '../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_styles.css';
import DecreasePopup from './DecreasePopup';
import ConfirmDialog from './ConfirmPopup';
import ReadyPopup from './ReadyPopup';

class Xhef extends React.Component {



    constructor(props) {
        super(props);
        this.props.loadXef(this.props.id);
        this.props.loadMachines(this.props.id);
        this.props.setXefLocal(this.props.id);
        this.props.allProducts();
        this.state = {
            currentTag: 0,
            periodTimer: 10,
            anchorEl: null,
            waste: false,
            production: false,
            projection: false,
            command: false,
            decrease: false,
            abierto: false,
            run: false,
            machine: false,
            source: undefined,
            xef: {},
            machines: [],
            data: [],
            tiposmaquina: [],
            confirm: undefined,
            producciondetenida: false
        };
        /*
        if (!this.source) {
            this.connect();
        }
        */
    }

    /*
    gotActivity = () => {
        if (this.keepaliveTimer != null) {
            clearTimeout(this.keepaliveTimer);
        }
        this.keepaliveTimer = setTimeout(this.connect, this.state.periodTimer * 1000);
    };

    connect = () => {
        this.gotActivity();
        if (this.source !== undefined) {
            this.source.removeEventListener('beat', this.updateTime, false);
            this.source.removeEventListener('produccion', this.updateStatus, false);
            this.source.close();
        }
        this.source = new EventSource(
            `${process.env.REACT_APP_API_SSE}/${this.props.id}`, // ?token=${sessionStorage.token.replace('Bearer ', '')}
            {
                headers: {
                    'Authorization': sessionStorage.token
                }
            }
        );
        this.source.addEventListener('beat', (message) => {
            this.updateTime(message);
            this.gotActivity();
            this.setState({ periodTimer: 10 });
        });
        this.source.addEventListener('produccion', (message) => {
            this.updateStatus(message);
        });
        this.source.onerror = function (err) {
            if (err) {
                console.error(err);
            }
        };
        //this.setState({ periodTimer: this.state.periodTimer + 5 });
    };
    */

    /*
    componentWillUnmount() {
        if (this.source !== undefined) {
            this.source.removeEventListener('beat', this.updateTime, false);
            this.source.removeEventListener('produccion', this.updateStatus, false);
            this.source.close();
        }
        if (this.keepaliveTimer != null) {
            clearTimeout(this.keepaliveTimer);
        }
    }

    updateTime = (message) => {
        //const data = JSON.parse(message.data);
        //this.props.xefTimeReference(data.timestamp);
    }

    updateStatus = (message) => {
        console.log(this.props.xef_reference_time.replace('T', ' ').substr(0, 19), message.data);
        const data = JSON.parse(message.data);
        this.props.addEvent(data);
    }
    */

    static getDerivedStateFromProps(props, state) {
        const { xef, machines, info, intl, xef_is_loading, xef_is_saving } = props;
        if (
            xef !== state.xef ||
            machines !== state.machines ||
            xef_is_loading !== state.xef_is_loading ||
            xef_is_saving !== state.xef_is_saving
        ) {
            const id = parseInt(props.id, 10);
            state.xef_is_loading = xef_is_loading;
            state.xef_is_saving = xef_is_saving;
            state.name =
                info &&
                    info.security &&
                    info.security.locals &&
                    info.security.locals.find((f) => f.id === id)
                    ? info.security.locals.find((f) => f.id === id).name
                    : intl.formatMessage({ id: 'xhef_all' });
            state.xef = xef;
            state.machines = machines;
            state.producciondetenida = xef ? xef.producciondetenida : false;
            state.activo = xef ? xef.activo : false;
            state.tiposmaquina = xef ? xef.tiposmaquina : [];
            state.abierto = xef && xef.desviacion ? xef.desviacion.abierto : false;
            state.proximaproduccion = xef ? xef.proximaproduccion : undefined;
            state.avisocapacidad = xef ? xef.avisocapacidad : undefined;
            state.data =
                xef && xef.producciones
                    ? xef.producciones.filter(
                        (f) =>
                            f.cerrada === null &&
                            (state.currentTag === 0 || f.estacion.nombre === state.currentTag),
                    )
                    : [];
            return state;
        }
        return null;
    }

    handleClick = () => {
        this.props.setHideAppBar(!this.props.window.appbar);
    };

    handleMenu = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = (option, value) => {
        if (option === 'waste' || option === 'production') {
            this.setState({ anchorEl: null, [option]: true });
        } else if (option === 'start_production') {
            if (this.state.proximaproduccion) {
                this.props
                    .pauseLocal(this.props.id, 0)
                    .then(() => this.setState({ anchorEl: null }))
                    .catch((error) => this.setState({ anchorEl: null, error: error.message }));
            } else {
                this.props
                    .edit({ id: this.props.id, activo: true })
                    .then(() => this.setState({ anchorEl: null }))
                    .catch((error) => this.setState({ anchorEl: null, error: error.message }));
            }
        } else if (option === 'machine') {
            if (value.estado >= 3) {
                this.setState({ machine: value });
            } else if (value.estado <= 2) {
                this.setState({
                    confirm: value,
                    confirm_type: 'machine',
                    confirm_title: this.props.intl.formatMessage({
                        id: 'xhef_machine_confirm_title',
                    }),
                    confirm_text: this.props.intl.formatMessage({
                        id: 'xhef_machine_confirm_message',
                    }),
                });
            }
        } else if (option === 'command' || option === 'decrease' || option === 'ready') {
            this.setState({ [option]: value });
        } else if (option === 'run') {
            this.setState({ run: value });
            /*if (!value.preparando) {
                this.setState({ run: value });
            } else if (
                value.preparando &&
                value.nextrun &&
                value.nextrun > this.props.xef_reference_time
            ) {
                this.setState({
                    confirm: value,
                    confirm_type: 'run',
                    confirm_title: this.props.intl.formatMessage({
                        id: 'xhef_run_command_confirm_title',
                    }),
                    confirm_text: this.props.intl.formatMessage({
                        id: 'xhef_run_command_confirm_message',
                    }),
                });
            } else {
                this.props
                    .production({
                        idLocal: this.props.id,
                        idProduccion: value.id,
                        cantidad: value.cantidad,
                        idMaquina: value.idMaquina,
                    })
                    .catch((error) => this.setState({ run: value }));
            }*/
        } else if (option === 'available') {
            if (value.nextrun) {
                this.setState({
                    confirm: value,
                    confirm_type: 'available',
                    confirm_title: this.props.intl.formatMessage({
                        id: 'xhef_available_confirm_title',
                    }),
                    confirm_text: this.props.intl.formatMessage({
                        id: 'xhef_available_confirm_message',
                    }),
                });
            }
        } else {
            this.setState({ anchorEl: null, error: false });
        }
    };

    handlePopup = (field, value) => {
        if (
            field === 'waste' ||
            field === 'machine' ||
            field === 'production' ||
            field === 'run' ||
            field === 'command' ||
            field === 'decrease' ||
            field === 'ready'
        ) {
            this.setState({ [field]: false, error: value });
        } else if (field === 'confirm') {
            if (
                value &&
                (this.state.confirm_type === 'run' || this.state.confirm_type === 'available')
            ) {
                const product = this.state.confirm;
                this.props
                    .production({
                        idLocal: this.props.id,
                        idProduccion: product.id,
                        cantidad: product.cantidad,
                        idMaquina: product.idMaquina,
                    })
                    .then(() =>
                        this.setState({
                            [field]: false,
                            confirm_text: '',
                            confirm_title: '',
                            confirm_type: '',
                        }),
                    )
                    .catch((error) => {
                        if (this.state.confirm_type === 'run') {
                            this.setState({ [field]: false, run: product });
                        } else {
                            this.setState({
                                [field]: false,
                                error: error.message,
                                confirm_text: '',
                                confirm_title: '',
                                confirm_type: '',
                            });
                        }
                    });
            } else if (value && this.state.confirm_type === 'machine') {
                const machine = this.state.confirm;
                this.props
                    .status(machine.id, true)
                    .then(() =>
                        this.setState({
                            [field]: false,
                            confirm_text: '',
                            confirm_title: '',
                            confirm_type: '',
                        }),
                    )
                    .catch((error) =>
                        this.setState({
                            [field]: false,
                            error: error.message,
                            confirm_text: '',
                            confirm_title: '',
                            confirm_type: '',
                        }),
                    );
            } else {
                this.setState({
                    [field]: false,
                    confirm_text: '',
                    confirm_title: '',
                    confirm_type: '',
                });
            }
        } else {
            this.setState({ [field]: value });
        }
    };

    handleChangeTab = (event, value) => {
        const { xef } = this.state;
        const data = xef
            ? xef.producciones.filter(
                (f) => f.cerrada === null && (value === 0 || f.estacion.nombre === value),
            )
            : [];
        this.setState({ currentTag: value, data: data });
    };

    render() {
        const {
            error,
            anchorEl,
            waste,
            production,
            command,
            decrease,
            run,
            machine,
            currentTag,
            data,
            confirm,
            ready,
            name,
            activo,
            tiposmaquina,
            abierto,
            xef_is_loading,
            xef_is_saving
        } = this.state;
        const { info, window, workstation, communications_pending } = this.props;
        const producciondetenida = !(activo && abierto);
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '58') &&
              info.security.licencias.some((f) => f.id === 154 && f.activo ))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            return (
                <div id="xhef" className="alerts width100 bg_cloudy_blue_30">
                    {(xef_is_loading || xef_is_saving) && <Loading open opacity />}
                    <div className="bg_ice_blue shadow">
                        <Tabs
                            name="currentTag"
                            id="currentTag"
                            value={currentTag}
                            onChange={this.handleChangeTab}
                            indicatorColor="primary"
                            textColor="primary"
                            centered
                        >
                            <Tab value={0} className={'tab_alert'} label={name} />
                            {workstation &&
                                workstation.length > 0 &&
                                workstation.map((s) => (
                                    <Tab
                                        key={`tab-${s.nombre}`}
                                        value={s.nombre}
                                        className={'tab_alert'}
                                        label={s.nombre}
                                    />
                                ))}
                        </Tabs>
                    </div>
                    <TabContainer>
                        <Panel
                            {...this.props}
                            tab={currentTag}
                            data={data}
                            abierto={abierto}
                            tiposmaquina={tiposmaquina}
                            producciondetenida={producciondetenida}
                            handleOpenCommand={this.handleClose}
                            handleOpenDecrease={this.handleClose}
                            handleOpenRun={this.handleClose}
                            handleOpenMachine={this.handleClose}
                        />
                    </TabContainer>
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            nonavbar={true}
                            onClose={this.handleClose}
                        />
                    )}
                    {(abierto && producciondetenida && !error) &&
                        <Snackbar
                            open={true}
                            variant="error"
                            text={"Produccion detenida, utilice el botón azul para reactivar la producción"}
                            nonavbar={true}
                            noclose
                        />
                    }
                    <Fab
                        aria-label="add"
                        className={'button_float_left bg_white'}
                        onClick={this.handleClick}
                    >
                        {(communications_pending && ((communications_pending.communiaciones + communications_pending.mensajes) > 0)) &&
                            <div className="pendingMessages margin_right_2" />
                        }
                        {!window.appbar ? (
                            <ExpandMenu color="primary" />
                        ) : (
                                <ContractMenu color="primary" />
                            )}
                    </Fab>
                    <Fab
                        aria-label="add"
                        color="primary"
                        className={'button_float'}
                        onClick={this.handleMenu}
                    >
                        <DotsIcon />
                    </Fab>
                    {anchorEl && (
                        <Popup
                            anchorEl={anchorEl}
                            abierto={true}
                            producciondetenida={producciondetenida}
                            handleClose={this.handleClose.bind(this)}
                        />
                    )}
                    {waste && <Waste {...this.props} handleClose={this.handlePopup} />}
                    {production && <Production {...this.props} handleClose={this.handlePopup} />}
                    {command && (
                        <CommandPopup
                            {...this.props}
                            tag={currentTag}
                            handleClose={this.handlePopup}
                        />
                    )}
                    {decrease && (
                        <DecreasePopup
                            {...this.props}
                            info={decrease}
                            handleClose={this.handlePopup}
                        />
                    )}
                    {run && <Run {...this.props} info={run} handleClose={this.handlePopup} />}
                    {machine && (
                        <Machine {...this.props} info={machine} handleClose={this.handlePopup} />
                    )}
                    {confirm && (
                        <ConfirmDialog
                            {...this.props}
                            title={this.state.confirm_title}
                            message={this.state.confirm_text}
                            onClose={this.handlePopup}
                        />
                    )}
                    {ready && (
                        <ReadyPopup
                            {...this.props}
                            tag={currentTag}
                            handleClose={this.handlePopup}
                        />
                    )}
                </div>
            );
        }
    }
}

Xhef.propTypes = {
    intl: intlShape.isRequired,
};

function mapStateToProps(state) {
    return {
        info: state.info,
        xef: state.xef,
        xef_is_saving: state.xef_is_saving,
        xef_is_loading: state.xef_is_loading,
        machines: state.machines,
        products: state.products,
        workstation: state.workstation,
        xef_reference_time: state.xef_reference_time,
        window: state.window,
        communications_pending: state.communications_pending,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        Object.assign({}, actions, actions_machine, actions_local, actions_products, home, actions_forecast),
        dispatch,
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Xhef)));



// WEBPACK FOOTER //
// ./src/components/complex/xhef/Index.js